export default __webpack_public_path__ + "static/logo-og-143fca38a370ade7b5593f61109f53b8.jpg";